import { useEffect, useState } from "react";

export type WizardCarouselItem = {
    cover_image: string;
    name: string;
    description: string;
    slug: string;
};

type WizardCarouselProps = {
    items: WizardCarouselItem[];
    onClick: (slug: string) => void;
};

function WizardCarousel({
                            items,
                            onClick,
                        }: WizardCarouselProps) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(3);

    const visibleItems = items.slice(
        currentIndex,
        currentIndex + itemsPerPage
    );

    const showPrevious = () => {
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
    };

    const showNext = () => {
        setCurrentIndex((prev) =>
            Math.min(prev + 1, items.length - itemsPerPage)
        );
    };

    useEffect(() => {
        const updateItemsPerPage = () => {
            if (window.innerWidth <= 768) {
                setItemsPerPage(1);
            } else if (window.innerWidth <= 1024) {
                setItemsPerPage(2);
            } else {
                setItemsPerPage(3);
            }
        };

        updateItemsPerPage();

        window.addEventListener("resize", updateItemsPerPage);

        return () => window.removeEventListener("resize", updateItemsPerPage);
    }, []);

    useEffect(() => {
        setCurrentIndex(0);
    }, [items]);

    return (
        <div className="range-slider">
            <button
                className={`arrow ${currentIndex === 0 ? "disabled" : ""}`}
                onClick={showPrevious}
                disabled={currentIndex === 0}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                    <g id="Group_918" data-name="Group 918" transform="translate(-792 -942)">
                        <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" transform="translate(792 942)" fill="#436ab3"/>
                        <path id="Path_14050" data-name="Path 14050" d="M13.25,4.5l-5,5,5,5" transform="translate(792.75 945)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </g>
                </svg>

            </button>

            <div
                className="range-items"
                style={{
                    gridTemplateColumns: `repeat(${visibleItems.length}, minmax(250px, 350px))`,
                }}
            >
                {visibleItems.map((item, index) => (
                    <div
                        key={index}
                        className="item-grid"
                        onClick={() => onClick(item.slug)}
                    >
                        <img
                            src={item.cover_image}
                            alt={item.name}
                            className="item-grid-image"
                        />


                        <div className="item-grid-overlay">
                            <h3>{item.name}</h3>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <button
                className={`arrow ${
                    items.length <= itemsPerPage ||
                    currentIndex >= items.length - itemsPerPage
                        ? "disabled"
                        : ""
                }`}
                onClick={showNext}
                disabled={
                    items.length <= itemsPerPage ||
                    currentIndex >= items.length - itemsPerPage
                }
            >
                <svg id="Group_917" data-name="Group 917" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                    <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" fill="#436ab3"/>
                    <path id="Path_14050" data-name="Path 14050" d="M8.25,4.5l5,5-5,5" transform="translate(2.75 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </svg>

            </button>
        </div>
    );
}

export default WizardCarousel;
